define('glu/grid/row/rowGroupHeader',['require','../../itemView','hbs!./rowGroupHeader.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        tmpl = require('hbs!./rowGroupHeader.hbs');

    return ItemView.extend({
        tagName: 'tr',
        className: 'grid-row-group-header',
        template: tmpl,

        events: {
            'click @ui.$rowSelector': 'handleSelectRow'
        },

        ui: {
            $rowSelector: '.group-row-selector'
        },

        initialize: function() {
            this.groupId = this.model.cid;

            if (this.model.get('hasRowSelector')) {
                this.listenTo(this.appBus, 'grid:selectRow:group:' + this.groupId, this.unSelectCheckBox);
            }
        },

        templateHelpers: function() {
            return {
                groupTitle: this.model.getGroupTitle(),
                groupId: this.groupId
            };
        },

        handleSelectRow: function(e) {
            // Broadcast the row select event.
            this.appBus.trigger('grid:selectAllRows:group:' + this.groupId, this);

            // Trigger event that all group is selected
            this.appBus.trigger('grid:group:selectAllRows', this);
        },

        unSelectCheckBox: function(e) {
            var rowSelectorClass = '.row-selector-group-' + this.groupId;

            // See how many rows are selected in the table.
            var allRowsSelected = this.$el.parents('table').find(rowSelectorClass + ':not(:checked)').size() === 0;

            // If all rows are selected, check the "select all group" box.
            if (allRowsSelected) {
                return;
            }
            this.ui.$rowSelector.prop('checked', false);
        }
    });
});

